import React from "react";
import { Container } from "@mui/material";
import PropTypes from "prop-types";
import ThemeProvider from "../theme/ThemeProvider";

const ComponentsContainer = ({ children, sx }) => {
  return (
    <ThemeProvider>
      <Container maxWidth={false} sx={sx}>
        {children}
      </Container>
    </ThemeProvider>
  );
};

ComponentsContainer.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object.isRequired,
};

export default ComponentsContainer;
